/* globals APP_NAME */
import { keysPixel } from "@mkt/analytics/constants"

import { Helmet } from "react-helmet"
import { ThemeProvider } from "@emotion/react"

import Metatags from "./components/Metatags"
import GlobalStyles from "../../styles/GlobalStyles"

const BaseLayout = ({ theme, customGlobalCss, appLayout, trackClicksOnApp, SEOProps, children }) => {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles customGlobal={customGlobalCss} />
            <div css={appLayout} onClick={trackClicksOnApp}>
                <noscript
                    dangerouslySetInnerHTML={{
                        __html: `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${keysPixel[APP_NAME]}&ev=PageView&noscript=1" />`,
                    }}
                />
                <Helmet htmlAttributes={{ lang: "pt-br" }} />
                <Metatags {...SEOProps} />
                {children}
            </div>
        </ThemeProvider>
    )
}

export default BaseLayout
